<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template slot="rowAction" slot-scope="text">
        <a-button type="link" size="small" @click="edit(text)">编辑</a-button>
        <a-divider type="vertical" />
        <a-button type="link" size="small" @click="setPrinterFoods(text)"
          >设置打印菜品</a-button
        >
        <a-divider type="vertical" />
        <a-popconfirm
          title="确定删除吗?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="del(text)"
        >
          <a-button type="link" size="small">删除</a-button>
        </a-popconfirm>
      </template>
    </data-table>
    <SetPrinterFood ref="SetPrinterFood" @update="reload"></SetPrinterFood>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import SetPrinterFood from "./SetPrinterFood";
export default {
  components: {
    DataTable,
    SetPrinterFood
  },
  data() {
    return {
      option: {},
      content: [
        {
          label: "名称",
          name: "Name",
          option: {
            rules: [{ required: true, message: "名称必填" }]
          }
        },
        {
          label: "Ip",
          name: "Ip",
          option: {
            rules: [{ required: true, message: "Ip必填" }]
          }
        },
        {
          label: "端口号",
          name: "Port",
          option: {
            rules: [{ required: true, message: "端口号必填" }]
          },
          type: "number",
          props: {
            min: 0,
            precision: 0
          }
        },
        {
          label: "打印方式",
          name: "PrintModel",
          type: "select",
          api: "Common_GetSelect",
          param: { Types: "PrintModel" },
          dataField: "Data.PrintModel"
        },
        {
          label: "状态",
          name: "Status",
          type: "switch"
        },
        {
          label: "备注",
          name: "Remark",
          type: "textarea"
        }
      ]
    };
  },
  created() {
    this.option = {
      headSearch: {
        colnum: 1,
        content: [
          {
            label: "关键字",
            name: "Keyword"
          }
        ]
      },
      form: {
        title: "打印机",
        width: 500,
        colnum: 1,
        content: this.content,
        add: {
          submitApi: "AddPrinter",
          onOpenAfter: () => {
            let values = { Status: true };
            return values;
          },
          onSubmitBefore: values => {
            return this.onSubmitBefore(values);
          }
        },
        edit: {
          submitApi: "EditPrinter",
          onOpenAfter: values => {
            values.PrintModel = String(values.PrintModel);
            values.Status = values.Status ? true : false;
            return values;
          },
          onSubmitBefore: values => {
            return this.onSubmitBefore(values);
          }
        },
        del: {
          submitApi: "DeletePriner"
        }
      },
      grid: {
        api: "GetPrinterList",
        dataField: "Data",
        pagination: false,
        props: {
          scroll: {
            x: 1500,
            y: "calc(100vh - 200px)"
          }
        },
        columns: [
          {
            title: "序号",
            width: 80,
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "名称",
            width: 200,
            dataIndex: "Name"
          },
          {
            title: "Ip",
            width: 150,
            dataIndex: "Ip"
          },
          {
            title: "端口号",
            width: 150,
            dataIndex: "Port"
          },
          {
            title: "打印方式",
            width: 150,
            dataIndex: "PrintModelName"
          },
          {
            title: "状态",
            width: 120,
            dataIndex: "Status",
            customRender: (text, record) => {
              if (text) {
                return <a-badge status="success" text={record.StatusName} />;
              } else {
                return <a-badge status="error" text={record.StatusName} />;
              }
            }
          },
          {
            title: "菜品数量",
            width: 120,
            dataIndex: "FoodCount"
          },
          {
            title: "备注",
            dataIndex: "Remark"
          },

          {
            title: "操作",
            dataIndex: "Id",
            width: 250,
            key: "action",
            fixed: "right",
            align: "center",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    onSubmitBefore(values) {
      return values;
    },
    edit(Id) {
      this.$refs.dataTable.edit(Id);
    },
    del(Id) {
      this.$refs.dataTable.del({ Id: Id });
    },
    reload() {
      this.$refs.dataTable.reload();
    },
    setPrinterFoods(id) {
      this.$refs.SetPrinterFood.show(id);
    }
  }
};
</script>

<style lang="less" scoped></style>
